/* ============================================================
   Luv Secret : PDP Enhancement Script
   Transforms wall-of-text descriptions into structured sections
   with accordions for collapsible deep-dives.
   ============================================================ */
(function () {
  'use strict';

  function init() {
    // Only run on product pages
    if (!document.body || !document.body.classList.contains('template-product')) {
      // Some themes don't set template-product. Detect by presence of product description.
      if (!document.querySelector('.product__description, .product__description.rte')) {
        return;
      }
    }

    var desc = document.querySelector('.product__description.rte, .product__description');
    if (!desc) return;
    if (desc.dataset.luvEnhanced === '1') return;
    desc.dataset.luvEnhanced = '1';

    var html = desc.innerHTML;

    // Split sections on <hr> tags
    var parts = html.split(/<hr\s*\/?>/i);
    if (parts.length < 2) {
      // Not in expected format — leave alone
      return;
    }

    // Headings that should ALWAYS be open (intro / hero section)
    var openByDefault = ['why this exists', 'why', 'the ritual', 'how it feels'];
    // Headings that should be accordions
    var accordionHeadings = [
      'formulation',
      'on skin',
      'how to use',
      'how to layer',
      'who it\u2019s for',
      'who its for',
      'who it\'s for',
      'ingredients',
      'full inci',
      'inci',
      'faqs',
      'faq',
      'q&a',
      'notes from the lab',
      'notes from the maker',
      'shipping & returns',
      'shipping and returns'
    ];

    function normalizeHeading(s) {
      return s.toLowerCase().replace(/[^a-z0-9 &\']/g, '').trim();
    }

    function extractHeading(htmlPart) {
      // Try to find <p><strong>X</strong></p> at the start
      var match = htmlPart.match(/^\s*<p>\s*<strong>([^<]+)<\/strong>\s*<\/p>/i);
      if (match) {
        return { heading: match[1].trim(), rest: htmlPart.replace(match[0], '').trim() };
      }
      // Also try <h2>X</h2>
      var h2match = htmlPart.match(/^\s*<h2>([^<]+)<\/h2>/i);
      if (h2match) {
        return { heading: h2match[1].trim(), rest: htmlPart.replace(h2match[0], '').trim() };
      }
      return { heading: null, rest: htmlPart.trim() };
    }

    // Build the new structure
    var newHtml = '';
    var firstNonEmpty = true;

    for (var i = 0; i < parts.length; i++) {
      var raw = parts[i].trim();
      if (!raw) continue;

      var info = extractHeading(raw);
      var heading = info.heading;
      var body = info.rest;

      // Skip the duplicate H1 title section (first part usually starts with <h1>)
      if (i === 0 && /^\s*<h1/i.test(body)) {
        // Strip the duplicate title H1
        body = body.replace(/^\s*<h1>[^<]*<\/h1>\s*/i, '');
        // Build a "hero" section (intro + bullets in blockquote)
        if (body) {
          newHtml += '<div class="luv-pdp-hero">' + body + '</div>';
        }
        firstNonEmpty = false;
        continue;
      }

      if (!heading) {
        // Free-form text between sections : show it as styled lede
        if (body) {
          newHtml += '<div class="luv-pdp-lede">' + body + '</div>';
        }
        continue;
      }

      var normalized = normalizeHeading(heading);
      var isAccordion = false;
      for (var k = 0; k < accordionHeadings.length; k++) {
        if (normalized.indexOf(normalizeHeading(accordionHeadings[k])) === 0) {
          isAccordion = true;
          break;
        }
      }
      var alwaysOpen = false;
      for (var j = 0; j < openByDefault.length; j++) {
        if (normalized.indexOf(normalizeHeading(openByDefault[j])) === 0) {
          alwaysOpen = true;
          break;
        }
      }

      var safeId = 'luv-pdp-' + normalized.replace(/\s+/g, '-').slice(0, 40);

      if (isAccordion) {
        var openAttr = alwaysOpen ? ' open' : '';
        newHtml += '' +
          '<details class="luv-pdp-section luv-pdp-accordion"' + openAttr + ' id="' + safeId + '">' +
            '<summary class="luv-pdp-section-head">' +
              '<span class="luv-pdp-section-eyebrow">' + heading + '</span>' +
              '<span class="luv-pdp-section-chev" aria-hidden="true">+</span>' +
            '</summary>' +
            '<div class="luv-pdp-section-body">' + body + '</div>' +
          '</details>';
      } else {
        newHtml += '' +
          '<div class="luv-pdp-section luv-pdp-section-open" id="' + safeId + '">' +
            '<div class="luv-pdp-section-head"><span class="luv-pdp-section-eyebrow">' + heading + '</span></div>' +
            '<div class="luv-pdp-section-body">' + body + '</div>' +
          '</div>';
      }
    }

    if (newHtml) {
      desc.innerHTML = newHtml;
      desc.classList.add('luv-pdp-enhanced');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-run if Shopify swaps content (e.g. PJAX)
  document.addEventListener('shopify:section:load', init);
})();
